var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/BasePopup/BasePopup.jinja"] = require( "front/components/BasePopup/BasePopup.jinja" );
dependencies["front/components/CommonFooterMembership/CommonFooterMembership.jinja"] = require( "front/components/CommonFooterMembership/CommonFooterMembership.jinja" );
dependencies["front/components/CommonStory/CommonStory.jinja"] = require( "front/components/CommonStory/CommonStory.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/GuildPopup/GuildPopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/GuildPopup/GuildPopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/components/BasePopup/BasePopup.jinja", true, "assets/app/front/pages/GuildPopup/GuildPopup.jinja", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
parentTemplate = t_5
for(var t_4 in parentTemplate.blocks) {
context.addBlock(t_4, parentTemplate.blocks[t_4]);
}
output += "\n\n";
env.getTemplate("front/components/CommonFooterMembership/CommonFooterMembership.jinja", false, "assets/app/front/pages/GuildPopup/GuildPopup.jinja", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(Object.prototype.hasOwnProperty.call(t_7, "CommonFooterMembership")) {
var t_10 = t_7.CommonFooterMembership;
} else {
cb(new Error("cannot import 'CommonFooterMembership'")); return;
}
context.setVariable("CommonFooterMembership", t_10);
output += "\n";
env.getTemplate("front/components/CommonStory/CommonStory.jinja", false, "assets/app/front/pages/GuildPopup/GuildPopup.jinja", false, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
t_11.getExported(function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
if(Object.prototype.hasOwnProperty.call(t_11, "CommonStory")) {
var t_14 = t_11.CommonStory;
} else {
cb(new Error("cannot import 'CommonStory'")); return;
}
context.setVariable("CommonStory", t_14);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupContent"))(env, context, frame, runtime, function(t_16,t_15) {
if(t_16) { cb(t_16); return; }
output += t_15;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupContent(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"GuildPopup\">\n        <div class=\"GuildPopup-headerImage\" data-animation=\"1\" data-animation-type=\"bubble-down\" data-animation-state=\"initial\">\n            <img src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"popupCover")),"w1366_url"), env.opts.autoescape);
output += "\"\n              srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"popupCover")),"w1920_url"), env.opts.autoescape);
output += " 1920w,\n                      ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"popupCover")),"w1680_url"), env.opts.autoescape);
output += " 1680w,\n                      ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"popupCover")),"w1366_url"), env.opts.autoescape);
output += " 1366w,\n                      ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"popupCover")),"w920_url"), env.opts.autoescape);
output += " 920w,\n                      ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"popupCover")),"w680_url"), env.opts.autoescape);
output += " 680w\"\n              sizes=\"(max-width: 759px) 1, ";
output += "\n                     (min-width: 760px) and (max-width: 979px) 681, ";
output += "\n                     calc(100% - 240px)\" ";
output += "\n              alt=\"\">\n        </div>\n\n        <div class=\"GuildPopup-title\"><a href=\"";
output += runtime.suppressValue((lineno = 21, colno = 50, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:guild"])), env.opts.autoescape);
output += "\">The Guild</a></div>\n        <h2 class=\"GuildPopup-caption\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"popupTitle"), env.opts.autoescape);
output += "</h2>\n        <h2 class=\"GuildPopup-credits\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"popupSubtitle"), env.opts.autoescape);
output += "</h2>\n\n        <div class=\"GuildPopup-content\">\n            ";
output += runtime.suppressValue((lineno = 26, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonStory"), "CommonStory", context, [runtime.makeKeywordArgs({"data": {"content": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"content"),"contenthtml": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"contenthtml")}})])), env.opts.autoescape);
output += "\n        </div>\n\n        ";
output += runtime.suppressValue((lineno = 29, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonFooterMembership"), "CommonFooterMembership", context, [runtime.makeKeywordArgs({"data": {"content": {"title": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"popupBottomTitle"),"image": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"popupBottomCover") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"popupCover"),"text": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"popupBottomTextRendered"),"imageCaption": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"popupBottomCoverCaption")}}})])), env.opts.autoescape);
output += "\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_popupContent: b_popupContent,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/GuildPopup/GuildPopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/GuildPopup/GuildPopup.jinja
// module id = 535
// module chunks = 0